'use client';

import { Error500Template } from '@repo/design-system';
import { recoverFromChunkError } from '@repo/web-chrome/lib/recover-from-chunk-error';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

interface IErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error, reset }: IErrorPageProps): JSX.Element {
  const t = useTranslations('errors');
  if (recoverFromChunkError(error)) {
    return <div aria-hidden />;
  }
  return (
    <Error500Template
      title={t('serverError.title')}
      description={t('serverError.body')}
      retryLabel={t('serverError.ctaRetry')}
      homeLabel={t('notFound.ctaHome')}
      digest={error.digest}
      onRetry={reset}
    />
  );
}
